import { CTooltip } from './CTooltip.js';

const CTooltipPlugin = {
    install: (app) => {
        app.component(CTooltip.name, CTooltip);
    },
};

export { CTooltip, CTooltipPlugin };
//# sourceMappingURL=index.js.map
